import { Box, Slide, Stack } from "@mui/material";
import { createContext, useContext, useState } from "react";

const SlideContext = createContext()
export function USlide(props) {
    const [page, setPage] = useState('')

    return <SlideContext.Provider value={{
        page,
        setPage
    }}>
        <Box sx={{ position: 'relative' }}>
            {props.children}
        </Box>
    </SlideContext.Provider>
}

export function USlideOutPage(props) {
    const { page } = useContext(SlideContext)
    const { name, children } = props;
    return <>
        <Slide
            sx={{ position: 'absolute', right: 0, left: 0 }}
            appear={false}
            direction="right"
            mountOnEnter
            unmountOnExit
            in={name === page}>
            <Box>
                {children}
            </Box>
        </Slide>
    </>
}
export function USlidePage(props) {
    const { page } = useContext(SlideContext)
    const { name, children } = props;
    return <>
        <Slide
            sx={{ position: 'absolute', right: 0, left: 0 }}
            direction="left"
            mountOnEnter
            unmountOnExit
            in={name === page}>
            <Box>
                {children}
            </Box>
        </Slide>
    </>
}

export function useSlide() {
    const { setPage } = useContext(SlideContext)

    return {
        setPage
    }
}


export function USlideLoading(props) {
    const { open, sx, leftSx, rightSx, } = props;
    const speed = '.3s';

    return <>
        <Box sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
        }}>
            <Box direction="row" sx={{ height: '100%', position: 'relative', overflow: 'hidden' }}>
                <Box sx={{
                    position: 'absolute',
                    top: 0,
                    right: open ? '101%' : '50%', // 50%
                    left: open ? '-1%' : '-50%', // -50%
                    bottom: 0,
                    transition: 'left ' + speed,
                    transition: 'right ' + speed,
                    zIndex: 100,
                    ...sx,
                    ...leftSx,
                }}></Box>
                <Box sx={{
                    position: 'absolute',
                    top: 0,
                    left: open ? '101%' : '50%', // 50%
                    right: open ? '-1%' : '-50%', // -50%
                    bottom: 0,
                    transition: 'right ' + speed,
                    transition: 'left ' + speed,
                    zIndex: 100,
                    ...sx,
                    ...rightSx,
                }}></Box>
            </Box>

        </Box>
        {props.children}
    </>
}